module.exports = __webpack_public_path__ + "static/img/249_TO8_2234_og.9623912.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/249_TO8_2234_og.jpg
// module id = V1Lt
// module chunks = 0